"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONLY_FOCUS = exports.ON_DID_MOUNT = exports.ADD_OR_UPDATE_EXTRA_LIBRARY = exports.REPLACE_BODY_FUNCTION = exports.FOCUS_CLASS = exports.FOCUS_FUNCTION = exports.GET_FUNCTION_LIST = void 0;
exports.GET_FUNCTION_LIST = 'CODE_EDITOR.GET_FUNCTION_LIST';
exports.FOCUS_FUNCTION = 'CODE_EDITOR.FOCUS_FUNCTION';
exports.FOCUS_CLASS = 'CODE_EDITOR.FOCUS_CLASS';
exports.REPLACE_BODY_FUNCTION = 'CODE_EDITOR.REPLACE_BODY_FUNCTION';
exports.ADD_OR_UPDATE_EXTRA_LIBRARY = 'CODE_EDITOR.ADD_OR_UPDATE_EXTRA_LIBRARY';
exports.ON_DID_MOUNT = 'CODE_EDITOR.ON_DID_MOUNT';
exports.ONLY_FOCUS = 'CODE_EDITOR.ONLY_FOCUS';
//# sourceMappingURL=actionTypes.js.map